import { render } from "./TextCellEditor.vue?vue&type=template&id=c5cf537c"
import script from "./TextCellEditor.vue?vue&type=script&lang=js"
export * from "./TextCellEditor.vue?vue&type=script&lang=js"

import "./TextCellEditor.vue?vue&type=style&index=0&id=c5cf537c&lang=css"

import exportComponent from "/web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__